import { Typography } from '@mui/material';
import React from 'react'

const CustomSliderTitle = ({ title }) => {
    return (
      <Typography id="" sx={{ fontSize: "12px", fontWeight: "400" }}>
        {title}
      </Typography>
    );
  };
export default CustomSliderTitle